import {emitLanguageChange} from "./htmlTranslation";
import {getI18n} from "./htmlTranslation";

window.onpopstate = function(event) {
    let stateLang = 'ru';
    if (event.state && event.state.hasOwnProperty('lang')) {
        stateLang = event.state.lang
    }

    getI18n().locale = stateLang;
    emitLanguageChange();
};